/*
 * Copyright (c) 2022 American Well Systems
 * All rights reserved.
 *
 * It is illegal to use, reproduce or distribute
 * any part of this Intellectual Property without
 * prior written authorization from American Well.
 *
 */
export const HEADERS = {
  SESSION_ID: 'X-Client-Session-Id',
  AUTHORIZATION: 'Authorization'
};

export const SESSION = {
  SESSION_ID: 'sessionId',
  AUTHORIZATION: 'vms-token',
  CONFERENCE: 'encounterResponse'
};

export const PRODUCT_DATA = {
  ID: 'Converge for EHRs',
};

export const INVITATIONS = {
  PATIENT_INVITATION: {
    NAME: 'PATIENT_INVITATION',
    SUBJECT: 'Patient Invite',
    CONFERENCE_ID: 'conferenceId',
    PARAMS: {
      DISPLAY_NAME: 'displayName'
    }
  }
};

export enum MODALITIES {
  SMS = 'SMS',
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  SIP = 'SIP'
}

export enum PARTICIPANT_ROLE {
  PATIENT = 'PATIENT',
  INVITED_GUEST = 'INVITED_GUEST',
  PRACTITIONER = 'PRACTITIONER',
  INTERPRETER = 'INTERPRETER'
}

export enum PARTICIPANT_STATUS {
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  INVITED_BY_HOST = 'invited by host',
  NONE = 'none',
  NOT_CONNECTED = 'not connected',
  WAITING = 'waiting'
}

export const MESSAGES = {
  invites_correlation: 'Correlation Id',
  invites_visit_now: 'Visit Now',
  invites_start_visit: 'Start Visit',
  invites_patient: 'Patient',
  invites_participants: 'Participants',
  invites_no_participants: 'There are currently no participants',
  invites_modal_invite: 'Invite',
  invites_modal_contact_method: 'Contact Method',
  invites_modal_close: 'Cancel',
  invites_modal_send: 'Send',
  invites_success: 'Invite sent to',
  invites_failure: 'Invite not sent due to invalid contact information',
  invites_mobile_input_label: 'Participant Mobile Number',
  invites_email_input_label: 'Participant Email Address',
  invites_email_error: 'Please enter your email in the format example@email.com',
  invites_phone_input_label: 'Participant Phone Number',
  invites_error_invalid_country_code: 'Invalid country code',
  invites_error_too_short: 'The value is too short',
  invites_error_too_long: 'The value is too long',
  invites_error_not_number: 'The value is not a phone number',
  invites_error_landline_or_voip: 'Warning: This number cannot receive texts',
  invites_error_invalid_number: 'This number is not valid',
};
